export default __webpack_public_path__ + "static/media/Freebooter's Chestguard of Stalking Fury.2910a94c.jpg";